import { cleanUnit } from '../../shared/utils/address-unit.util';

export interface IPatientLocationHistory {
	locationId: number;
	current: number;
	isActive: boolean;
	use: string | null;
	addressId: number;
	unit: string | null;
	patientId: number;
	type: string;
	location: string;
	address: {
		address1: string;
		address2: string | null;
		unit: string | null;
		city: string;
		county: string | null;
		state: string;
		zipcode: string;
		latLong: string | null;
		type: string;
		location: string;
		status: string;
	};
	status: string;
}

export class PatientLocationHistory implements IPatientLocationHistory {
	locationId: number;
	current: number;
	isActive: boolean;
	use: string | null;
	addressId: number;
	unit: string | null;
	patientId: number;
	type: string;
	location: string;
	address: {
		address1: string;
		address2: string | null;
		unit: string | null;
		city: string;
		county: string | null;
		state: string;
		zipcode: string;
		latLong: string | null;
		type: string;
		location: string;
		status: string;
	};
	status: string;

	constructor(data: any) {
		this.locationId = data.location_id || data.locationId || 0;
		this.isActive = data.is_active !== undefined ? !!data.is_active : !!data.current;
		this.current = this.isActive ? 1 : 0;
		this.use = data.use || null;
		this.addressId = data.address_id || data.addressId || 0;
		this.unit = data.unit || null;
		this.patientId = data.patient_id || data.patientId || 0;
		this.type = data.type || '';
		this.location = data.location || '';
		this.address = {
			address1: data.address?.address_1 || data.address?.address1 || '',
			address2: data.address?.address_2 || data.address?.address2 || null,
			unit: data.address?.unit || null,
			city: data.address?.city || '',
			county: data.address?.county || null,
			state: data.address?.state || '',
			zipcode: data.address?.zipcode || '',
			latLong: data.address?.lat_long || data.address?.latLong || null,
			type: data.address?.type || '',
			location: data.address?.location || '',
			status: data.address?.status || ''
		};
		this.status = data.status || '';
		this.isFacility = !!(data.facility || data.facility_id);
		this.unitDisplay = 'unit_display' in data ? cleanUnit(data.unit_display) : undefined;
	}

	// DOVE-2669 — a home location's unit (plus any line 2) as resolved by the API; undefined on older responses.
	private isFacility: boolean;
	private unitDisplay?: string;

	get fullAddress(): string {
		const afterStreet =
			!this.isFacility && this.unitDisplay !== undefined ? this.unitDisplay : cleanUnit(this.address.address2);
		const parts = [
			this.address.address1,
			afterStreet,
			this.address.city,
			this.address.state,
			this.address.zipcode
		].filter((part) => part && part.trim() !== '');

		return parts.join(', ');
	}

	get displayLabel(): string {
		return `${this.fullAddress}`;
	}
}
